import React, { lazy } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Layout from "./components/Layout";

const Home = lazy(
  () => import("./pages/Home/Home" /* webpackChunkName: "home" */)
);
const Users = lazy(
  () => import("./pages/Users/Users" /* webpackChunkName: "home" */)
);
const Artworks = lazy(
  () => import("./pages/Artworks/Artworks" /* webpackChunkName: "home" */)
);
const Invoice = lazy(
  () => import("./pages/Invoice/Invoice" /* webpackChunkName: "home" */)
);
const Charts = lazy(
  () => import("./pages/Charts/Charts" /* webpackChunkName: "home" */)
);
const Insights = lazy(
  () => import("./pages/Interviews/Insights" /* webpackChunkName: "home" */)
);

const CreateInterview = lazy(
  () =>
    import("./pages/Interviews/CreateInterview" /* webpackChunkName: "home" */)
);
const UpdateInterview = lazy(
  () =>
    import("./pages/Interviews/UpdateInterview" /* webpackChunkName: "home" */)
);
const Screens = lazy(
  () => import("./pages/Screens/Screens" /* webpackChunkName: "home" */)
);
const CreateArticle = lazy(
  () => import("./pages/Articles/CreateArticle" /* webpackChunkName: "home" */)
);
const UpdateArticle = lazy(
  () => import("./pages/Articles/UpdateArticle" /* webpackChunkName: "home" */)
);

const Collections = lazy(
  () => import("./pages/Collections/Collections" /* webpackChunkName: "home" */)
);
const Physical = lazy(
  () => import("./pages/Physical/Physical" /* webpackChunkName: "home" */)
);
const PhysicalOrders = lazy(
  () =>
    import("./pages/PhysicalOrders/PhysicalOrders" /* webpackChunkName: "home" */)
);

const Routers = ({ children }: { children?: React.ReactNode }) => (
  <Router>
    {children}
    <Switch>
      <Route exact path="/">
        <Layout>
          <Home />
        </Layout>
      </Route>
      <Route exact path="/users">
        <Layout>
          <Users />
        </Layout>
      </Route>
      <Route exact path="/art">
        <Layout>
          <Artworks />
        </Layout>
      </Route>
      <Route exact path="/insights">
        <Layout>
          <Insights />
        </Layout>
      </Route>
      <Route exact path="/createInterview">
        <Layout>
          <CreateInterview />
        </Layout>
      </Route>
      <Route exact path="/invoice">
        <Layout>
          <Invoice />
        </Layout>
      </Route>
      <Route exact path="/charts">
        <Layout>
          <Charts />
        </Layout>
      </Route>
      <Route exact path="/interview/:id">
        <Layout>
          <UpdateInterview />
        </Layout>
      </Route>
      <Route exact path="/screens">
        <Layout>
          <Screens />
        </Layout>
      </Route>
      <Route exact path="/createEditorial">
        <Layout>
          <CreateArticle />
        </Layout>
      </Route>
      <Route exact path="/article/:id">
        <Layout>
          <UpdateArticle />
        </Layout>
      </Route>
      <Route exact path="/collections">
        <Layout>
          <Collections />
        </Layout>
      </Route>
      <Route exact path="/physical">
        <Layout>
          <Physical />
        </Layout>
      </Route>
      <Route exact path="/physicalOrders">
        <Layout>
          <PhysicalOrders />
        </Layout>
      </Route>
    </Switch>
  </Router>
);
export default Routers;
